module.exports = __webpack_public_path__ + "static/media/star.e738b6f9.svg";